// Borna bug batch 1 (items 4 + 8): the ONE piece of state behind the Borna
// logout confirmation. It exists so that every logout entry point -- the
// student sidebar row, the mobile bottom-nav item, and anything added later --
// raises the SAME dialog instance, which `App/index.vue` renders once at the
// shell root (a dialog rendered inside the bottom nav would be trapped in that
// bar's `z-index: 40` stacking context).
//
// Deliberately NOT the legacy `app/modal` system: that renders
// `ModalTemplate`'s full-screen slide-up chrome, which is not the V2 logout
// dialog. No auth or session semantics live here -- confirming simply calls
// the existing `AuthService.logout`.
export default {
  namespaced: true,
  state: {
    isShown: false,
  },
  mutations: {
    setIsShown: (state, b) => (state.isShown = !!b),
  },
  actions: {
    show: ({ commit }) => commit('setIsShown', true),
    hide: ({ commit }) => commit('setIsShown', false),
  },
}
